const deepReplacePropertiesValue = (obj, operations = {}) => {
  if (typeof obj !== 'object') return obj

  if (Array.isArray(obj)) {
    return obj.map(item => deepReplacePropertiesValue(item, operations))
  }

  return Object.entries(obj).reduce((acc, [key, value]) => {
    const operation = operations[key]
    acc[key] = deepReplacePropertiesValue(operation ? operation(value, acc) : value, operations)
    return acc
  }, {})
}

export default deepReplacePropertiesValue
